import React, { useEffect, useState } from 'react';
import * as api from '../../billMemory/api';
import { shortDate } from '../../billMemory/core';

const WORDS = {
  learn: 'learned', confirm: 'confirmed', trust: 'became Trusted', replace: 'replaced', confuse: 'became Confusing', vote: 'got a vote',
  not_stock: 'marked Not stock', unlearn: 'taken back', revert: 'taken back by a revert', import: 'imported from history',
  manual_add: 'added by hand', manual_change_item: 'pointed to a different item', manual_make_fixed: 'made fixed',
  manual_always_ask: 'set to Always ask', manual_pause: 'paused', manual_resume: 'resumed', manual_change_scope: 'moved to another scope',
  manual_forget: 'forgotten', manual_forget_user: 'forgotten with everything that user taught', manual_undo: 'restored by Undo',
  manual_dictionary_off: 'dictionary group switched off', manual_dictionary_on: 'dictionary group switched on', manual_own_gstin: 'own GSTIN changed',
  autopilot_start: 'Bill Memory started learning (default)', autopilot_on: 'Bill Memory turned On automatically',
  autopilot_back: 'Bill Memory stepped back to Shadow automatically',
  cleanup_fragment: 'forgotten — it was letters typed to search, not a name', cleanup_restore: 'restored',
  corrected_after_save: 'was corrected after saving', manual_forget_clue: 'vendor GSTIN or phone forgotten',
  audit_wrong: 'marked wrong in the weekly check', owner_wrong: 'marked "This was wrong"',
  replay: 'past bills replayed to measure Bill Memory', autopilot_ready: 'a part of Bill Memory is ready to turn on, waiting for approval',
  autopilot_unready: 'a part of Bill Memory went back to Shadow (no longer ready)', admin_approve: 'a part of Bill Memory was approved by Invexis',
  admin_not_yet: 'a part of Bill Memory was kept in Shadow by Invexis',
  admin_switches: 'Bill Memory switches changed by Invexis', admin_default: 'back to the default Bill Memory settings (Invexis)',
};

const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
/** An automatic or admin move, named by its source (Phase 1 minor 5): "Vendor lessons turned On automatically". */
const SOURCE_MOVES = {
  autopilot_on: (w) => `${cap(w)} turned On automatically`,
  autopilot_back: (w) => `${cap(w)} stepped back to Shadow automatically`,
  autopilot_ready: (w) => `${cap(w)} ready to turn on, waiting for approval`,
  autopilot_unready: (w) => `${cap(w)} back to Shadow (no longer ready)`,
  admin_approve: (w) => `${cap(w)} approved by Invexis`,
  admin_not_yet: (w) => `${cap(w)} kept in Shadow by Invexis`,
};
const actionText = (g) => (g.source_words && SOURCE_MOVES[g.action] ? SOURCE_MOVES[g.action](g.source_words) : (WORDS[g.action] || String(g.action).replace(/_/g, ' ')));

/** Activity: every change to any lesson, newest first, with who and when. */
export default function ActivityTab() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.getActivity().then((r) => setRows(r.rows || [])).catch(() => setRows([])); }, []);
  if (!rows) return <div className="bm-note">Loading…</div>;
  if (!rows.length) return <div className="bm-note">Nothing has changed yet.</div>;
  return (
    <ul className="bm-log">
      {rows.map((g) => (
        <li key={g.id}>
          {`${shortDate(g.at)}: ${g.name ? `"${g.name}" ` : ''}${actionText(g)}${g.detail ? ` ${g.detail}` : ''}`}
          {g.user ? ` by ${g.user}` : ''}
          {g.stock_in_id ? ` (stock-in #${g.stock_in_id})` : ''}.
        </li>
      ))}
    </ul>
  );
}
